import React from 'react';
import i18n from 'i18next';
import './PageUnavailable.css';

const PageUnavailable = () => (
  <div className="page-unavailable">
    <h3>{i18n.t('common:PageUnavailable')}</h3>
    <p>{i18n.t('common:PageUnavailableDescription')}</p>
  </div>
);

export default PageUnavailable;



// WEBPACK FOOTER //
// ./src/components/PageUnavailable/PageUnavailable.jsx